ACC.paginationsort = {
  downUpKeysPressed: false,

  bindAll: function() {
    this.bindPaginaSort();
  },

  bindPaginaSort: function() {
  /* eslint-disable no-with */
    with (ACC.paginationsort) {
    /* eslint-enable no-with */
      /* eslint-disable no-undef*/
      bindSortForm($('#sort_form1'));
      bindSortForm($('#sort_form2'));
      /* eslint-enable no-undef*/
    }
  },

  isIE: function() {
    return $('html').hasClass('lt-ie8');
  },

  bindSortForm: function(sortForm) {
    if (this.isIE()) {
      this.sortFormIEFix($(sortForm).children('select'), $(sortForm).children('select').val());
    }

    $('.viewoptions').on('change', function() {
      this.form.submit();
    });


    sortForm.change(function() {
      /* eslint-disable no-negated-condition*/
      if (!ACC.paginationsort.isIE()) {
        /* eslint-enable no-negated-condition*/
        this.submit();
      } else {
        if (!ACC.paginationsort.downUpPressed) {
          this.submit();
        }

        ACC.paginationsort.downUpPressed = false;
      }
    });
  },

  sortFormIEFix: function(sortOptions, selectedOption) {
    sortOptions.keydown(function(event) {
      /* eslint-disable brace-style */
      if (event.keyCode === 38 || event.keyCode === 40) {
        ACC.paginationsort.downUpPressed = true;
      }

      else if (event.keyCode === 13 && selectedOption !== $(this).val()) {
        $(this).parent().submit();
      }
      /* eslint-enable brace-style */
      else {
        ACC.paginationsort.downUpPressed = false;
      }
    });
  }
};

$(document).ready(function() {
  ACC.paginationsort.bindAll();
});

